 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"market-selection":"market-selection","markets-forecastmodal":"markets-forecastmodal","markets-pickermodal":"markets-pickermodal","markets-pricemodal":"markets-pricemodal","stripe-js":"stripe-js"}[chunkId]||chunkId) + "." + {"chunk-00b98f47":"8aaf91a8","chunk-2c9a446f":"cc6c5077","chunk-d8cbe3c0":"4b674893","chunk-05bce5d9":"078d0f59","chunk-0a02b93f":"f7164d7f","chunk-0a306cd3":"530ff7fc","chunk-18527387":"0653d8ce","chunk-19664f68":"96da0d95","chunk-1ba71590":"aea23ec1","chunk-1c294d7a":"7294d4e3","chunk-1d4f0a1a":"8c1ce30c","chunk-3826b6de":"08259d99","chunk-3ad34514":"2cddfff2","chunk-3bb646fd":"ac03fa61","chunk-3eadcd9e":"ebc05a94","chunk-4b4c1de2":"2ca28e40","chunk-1c4a1834":"57e0bd70","chunk-3629128a":"b6adff4e","chunk-6e8afa06":"306c552d","chunk-21e34634":"b960a1b6","chunk-4363da79":"a76f5c21","chunk-62a7e35d":"90413448","chunk-0d9c07be":"ec591238","chunk-6aa2ae2c":"d243d052","chunk-04f7914b":"86f42042","chunk-2c602b8f":"436cf416","chunk-5b833136":"24dbc643","chunk-13d1fc70":"bd3eca28","chunk-e497b83c":"c439e048","market-selection":"6d814a11","chunk-3ae52b54":"411bd4a2","chunk-06df324a":"1943539b","chunk-01c8ff03":"53ddadee","chunk-1e1e5fd4":"11c8a624","chunk-3c306990":"926de411","chunk-61cb7ec1":"cf141e39","chunk-69eecd15":"0d95e4d0","chunk-05a25ba5":"b422b58b","chunk-08d7f7d6":"2fe067df","chunk-0b0b3d8b":"ed15b323","chunk-10a5509e":"f4d8d553","chunk-179c4352":"49e0637c","chunk-1e5f6291":"184ac8c8","chunk-20301756":"713b2e20","chunk-2d349ee8":"40d9dfc4","chunk-3a9a1411":"66cfde07","chunk-3fce75c9":"84e29102","chunk-4ebc3f1a":"c2c3fb44","chunk-522a4b5d":"4ba7120c","chunk-527971c8":"9ba229ab","chunk-5924f368":"dfea748b","chunk-5a4513d1":"6a367956","chunk-64561a6e":"e48b6817","chunk-6f314881":"af852aa8","chunk-728dcc7f":"123db939","chunk-7f4d4a56":"2ba19bd0","chunk-87c8a562":"366bebfb","chunk-966f1934":"8c42d4d0","chunk-9ee90754":"b0e7e789","chunk-f3d8838e":"e5cddfc3","chunk-fbb82a1e":"075e9c22","chunk-97a7ff30":"6159ee0f","chunk-e959806e":"aee3e510","chunk-4bcb869c":"268c4d26","chunk-5624a32e":"770a677e","chunk-7b1532d0":"bb07b48b","chunk-5b38c3a6":"1367c126","chunk-c2d39846":"cf03b2d2","chunk-7977a92e":"1689aa13","chunk-79fdb3bd":"12ce9bfd","chunk-800d2cfe":"55f99ce2","chunk-d83d64d2":"a4060414","chunk-fef5b638":"d9af06bb","chunk-2d21a785":"72f2ddb7","markets-forecastmodal":"ffb7e9f4","markets-pickermodal":"9d11615c","markets-pricemodal":"8964551b","stripe-js":"41c032d0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-00b98f47":1,"chunk-2c9a446f":1,"chunk-d8cbe3c0":1,"chunk-05bce5d9":1,"chunk-0a02b93f":1,"chunk-0a306cd3":1,"chunk-18527387":1,"chunk-19664f68":1,"chunk-1ba71590":1,"chunk-1c294d7a":1,"chunk-1d4f0a1a":1,"chunk-3826b6de":1,"chunk-3ad34514":1,"chunk-3bb646fd":1,"chunk-3eadcd9e":1,"chunk-4b4c1de2":1,"chunk-1c4a1834":1,"chunk-3629128a":1,"chunk-6e8afa06":1,"chunk-21e34634":1,"chunk-4363da79":1,"chunk-62a7e35d":1,"chunk-0d9c07be":1,"chunk-6aa2ae2c":1,"chunk-04f7914b":1,"chunk-2c602b8f":1,"chunk-5b833136":1,"chunk-13d1fc70":1,"chunk-e497b83c":1,"market-selection":1,"chunk-3ae52b54":1,"chunk-06df324a":1,"chunk-01c8ff03":1,"chunk-1e1e5fd4":1,"chunk-3c306990":1,"chunk-61cb7ec1":1,"chunk-69eecd15":1,"chunk-05a25ba5":1,"chunk-08d7f7d6":1,"chunk-0b0b3d8b":1,"chunk-10a5509e":1,"chunk-179c4352":1,"chunk-1e5f6291":1,"chunk-20301756":1,"chunk-2d349ee8":1,"chunk-3a9a1411":1,"chunk-3fce75c9":1,"chunk-4ebc3f1a":1,"chunk-522a4b5d":1,"chunk-527971c8":1,"chunk-5924f368":1,"chunk-5a4513d1":1,"chunk-64561a6e":1,"chunk-6f314881":1,"chunk-728dcc7f":1,"chunk-7f4d4a56":1,"chunk-87c8a562":1,"chunk-966f1934":1,"chunk-9ee90754":1,"chunk-f3d8838e":1,"chunk-fbb82a1e":1,"chunk-97a7ff30":1,"chunk-e959806e":1,"chunk-4bcb869c":1,"chunk-5624a32e":1,"chunk-7b1532d0":1,"chunk-5b38c3a6":1,"chunk-c2d39846":1,"chunk-7977a92e":1,"chunk-79fdb3bd":1,"chunk-800d2cfe":1,"chunk-d83d64d2":1,"chunk-fef5b638":1,"markets-forecastmodal":1,"markets-pickermodal":1,"markets-pricemodal":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"market-selection":"market-selection","markets-forecastmodal":"markets-forecastmodal","markets-pickermodal":"markets-pickermodal","markets-pricemodal":"markets-pricemodal","stripe-js":"stripe-js"}[chunkId]||chunkId) + "." + {"chunk-00b98f47":"37fe7308","chunk-2c9a446f":"2ff694b0","chunk-d8cbe3c0":"a6854125","chunk-05bce5d9":"0942afbd","chunk-0a02b93f":"53f89edb","chunk-0a306cd3":"c9b8f644","chunk-18527387":"ac2beb9b","chunk-19664f68":"1d02a09d","chunk-1ba71590":"e1656956","chunk-1c294d7a":"2397848f","chunk-1d4f0a1a":"691863e4","chunk-3826b6de":"e4110c19","chunk-3ad34514":"73e202ec","chunk-3bb646fd":"8bb01e1e","chunk-3eadcd9e":"14f796c0","chunk-4b4c1de2":"eebc48c3","chunk-1c4a1834":"bfbaf56c","chunk-3629128a":"7d1ed8da","chunk-6e8afa06":"4de8a1c2","chunk-21e34634":"06bfe230","chunk-4363da79":"918ce497","chunk-62a7e35d":"655b7158","chunk-0d9c07be":"02e17ec8","chunk-6aa2ae2c":"6df269c9","chunk-04f7914b":"2385040b","chunk-2c602b8f":"17b1cff1","chunk-5b833136":"edd32dfd","chunk-13d1fc70":"969f1b41","chunk-e497b83c":"281d5ab5","market-selection":"99d63f72","chunk-3ae52b54":"6e3fe909","chunk-06df324a":"391c4a55","chunk-01c8ff03":"80ed6c08","chunk-1e1e5fd4":"eb6fb952","chunk-3c306990":"582a144e","chunk-61cb7ec1":"af10440f","chunk-69eecd15":"3c63bbe1","chunk-05a25ba5":"e9769b30","chunk-08d7f7d6":"b9999719","chunk-0b0b3d8b":"67b55c16","chunk-10a5509e":"7ca99a80","chunk-179c4352":"c76ec73a","chunk-1e5f6291":"719b629a","chunk-20301756":"9a7ef3ae","chunk-2d349ee8":"9de3c921","chunk-3a9a1411":"8f94f36d","chunk-3fce75c9":"85655e82","chunk-4ebc3f1a":"b5babf73","chunk-522a4b5d":"a9a74ecd","chunk-527971c8":"4e355e77","chunk-5924f368":"6c400dc5","chunk-5a4513d1":"70d0b6a6","chunk-64561a6e":"ce55d700","chunk-6f314881":"a2cef0e1","chunk-728dcc7f":"d623b468","chunk-7f4d4a56":"37e4ef20","chunk-87c8a562":"48f1245c","chunk-966f1934":"e0605715","chunk-9ee90754":"784d76f6","chunk-f3d8838e":"23ccbed5","chunk-fbb82a1e":"d3d04e51","chunk-97a7ff30":"f862ce10","chunk-e959806e":"06bfe230","chunk-4bcb869c":"b8590211","chunk-5624a32e":"e9fae0e8","chunk-7b1532d0":"08711639","chunk-5b38c3a6":"c84635d3","chunk-c2d39846":"ad2c71d6","chunk-7977a92e":"073617d8","chunk-79fdb3bd":"f6aaa770","chunk-800d2cfe":"109184e0","chunk-d83d64d2":"0942afbd","chunk-fef5b638":"66f09912","chunk-2d21a785":"31d6cfe0","markets-forecastmodal":"460af5ff","markets-pickermodal":"cfb760cd","markets-pricemodal":"193c6923","stripe-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/my-market-app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
